// extracted by mini-css-extract-plugin
export default {"form":"Form_form__jgFaD","form-outline":"Form_form-outline__+3wF4","error":"Form_error__w9aTc","feedback":"Form_feedback__iz7C5"};